import { render, staticRenderFns } from "./ProposalRatingAndClauses.vue?vue&type=template&id=0318e940"
import script from "./ProposalRatingAndClauses.vue?vue&type=script&lang=js"
export * from "./ProposalRatingAndClauses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports